import { CampaignSlider } from "@app/home/components/social-feed/CampaignSlider";
import { CampaignVisual } from "@app/home/components/social-feed/CampaignVisual";
import type { SocialHomeBanner, SocialHomeSlider } from "@core/home/types";

type ModernHomeCampaignsProps = {
  banners?: SocialHomeBanner[];
  sliders?: SocialHomeSlider[];
};

export function ModernHomeCampaigns({
  banners = [],
  sliders = [],
}: ModernHomeCampaignsProps) {
  const visibleSliders = sliders
    .map(slider => ({
      ...slider,
      banners: slider.banners.filter(
        banner =>
          banner.image?.url || banner.title || banner.description,
      ),
    }))
    .filter(slider => slider.banners.length > 0)
    .slice(0, 2);
  const visibleBanners = banners
    .filter(
      banner => banner.image?.url || banner.title || banner.description,
    )
    .slice(0, 4);

  if (visibleBanners.length === 0 && visibleSliders.length === 0) return null;

  return (
    <section className="space-y-5">
      {visibleSliders.map(slider => (
        <CampaignSlider
          key={slider.id}
          banners={slider.banners}
          canCycle={slider.banners.length > 1}
        />
      ))}

      {visibleBanners.length > 0 ? (
        <div
          className={`grid gap-4 ${visibleBanners.length > 1 ? "lg:grid-cols-2" : ""}`}>
          {visibleBanners.map(banner => (
            <CampaignVisual key={banner.id} banner={banner} />
          ))}
        </div>
      ) : null}
    </section>
  );
}
